// Market sort order by base symbol (1 = first position)
export const MARKET_SORT_ORDER: Record<string, number> = {
  BTC: 1,
  ETH: 2,
  SOL: 3,
  HYPE: 4,
  ENA: 5,
  APT: 6,
};

export const DEFAULT_MARKET_CONFIG: MarketParams = {
  pricePrecision: 4,
  precision: [
    { value: "100", label: "100" },
    { value: "10", label: "10" },
    { value: "1", label: "1" },
    { value: "0.1", label: "0.1" },
    { value: "0.01", label: "0.01" },
    { value: "0.001", label: "0.001" },
    { value: "0.0001", label: "0.0001" },
  ],
};

export interface MarketParams {
  pricePrecision: number;
  precision: { value: string; label: string }[];
}

export const MARKET_CONFIG: Record<string, MarketParams> = {
  "0xbfab967691f66638552a4c612cd96899308c1e19e940f584260723060088ee61": {
    ...DEFAULT_MARKET_CONFIG,
    precision: [
      { value: "100", label: "100" },
      { value: "50", label: "50" },
      { value: "10", label: "10" },
      { value: "1", label: "1" },
      { value: "0.1", label: "0.1" },
      { value: "0.01", label: "0.01" },
    ],
  },
  "0x782c0c9f3f4affefff3d37a2d82e793fae9dd8920a36516583684b6ebd5ea232": {
    ...DEFAULT_MARKET_CONFIG,
    precision: [
      { value: "100", label: "100" },
      { value: "50", label: "50" },
      { value: "10", label: "10" },
      { value: "1", label: "1" },
      { value: "0.1", label: "0.1" },
      { value: "0.01", label: "0.01" },
      { value: "0.001", label: "0.001" },
      { value: "0.0001", label: "0.0001" },
    ],
  },
  "0xa40dfc869ddfd94e32dcb28917423004d72006f7131320ad05e4108b9b063f75": {
    ...DEFAULT_MARKET_CONFIG,
    precision: [
      { value: "0.1", label: "0.1" },
      { value: "0.01", label: "0.01" },
      { value: "0.001", label: "0.001" },
      { value: "0.0001", label: "0.0001" },
      { value: "0.00001", label: "0.00001" },
    ],
  },
  "0xb0a20bce45e4c6a747aaebfe8090b57106a9771b2a767c8198fe04a6ddb283a5": {
    ...DEFAULT_MARKET_CONFIG,
    precision: [
      { value: "0.1", label: "0.1" },
      { value: "0.01", label: "0.01" },
      { value: "0.001", label: "0.001" },
      { value: "0.0001", label: "0.0001" },
      { value: "0.00001", label: "0.00001" },
    ],
  },
};
